import script from "./ArrowLink.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrowLink.vue?vue&type=script&setup=true&lang=js"

import "./ArrowLink.vue?vue&type=style&index=0&id=d88af8da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d88af8da"]])

export default __exports__